
import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'antd';
import { FaExchangeAlt, FaChevronRight } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { getFlightDomesticList } from '../../../services/flight/flightServices';
import moment from 'moment';

const PopularFlight = () => {
    const [domesticData, setDomesticData] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const fetchDomesticData = async () => {
        try {
            const data = await getFlightDomesticList();
            setDomesticData(data?.data || []);
        } catch (err) {
            setError('Failed to fetch domestic flights');
        }
    };

    useEffect(() => {
        fetchDomesticData();
    }, []);

    const formattedTomorrow = moment().add(1, 'days').format('DD/MMM/YYYY');

    const handleFlightClick = (flight) => {
        sessionStorage.setItem('selectFromCity', JSON.stringify(flight?.from_city));
        sessionStorage.setItem('selectFromCityName', JSON.stringify(flight?.from_city_airport));
        sessionStorage.setItem('selectTOCity', JSON.stringify(flight?.to_city));
        sessionStorage.setItem('selectTOCityName', JSON.stringify(flight?.to_city_airport));
        sessionStorage.setItem('seatTypeflight', JSON.stringify("ECONOMY"));
        sessionStorage.setItem('returnFlight', JSON.stringify('oneWay'));
        sessionStorage.setItem('DepartureFlight', JSON.stringify(formattedTomorrow));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(1));
        sessionStorage.setItem('selectChildflight', JSON.stringify(0));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(0));
        const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        navigate(`/flights/${urlIdDynamic}`);
    };

    return (
        <section className="flight-area ptb-70 pb-5">
            <div className="container">
                <Card>
                    <div className="section-title mb-3">
                        <div>
                            <h3>Popular Domestic Destinations  </h3>
                            <span className="top-title">Search Flights & Places Hire to our most popular destinations</span>
                        </div>
                        <Link to="/popular-domestic-destinations" aria-label="See More Flights">See more destinations</Link>
                    </div>
                    <Row gutter={20}>
                        {domesticData?.slice(0, 9).map((flight) => {
                            return (
                                <Col key={flight.id} lg={8} md={12} xs={24}>
                                    <div className="card flight-box" onClick={() => handleFlightClick(flight)}>
                                        <div className="card-body">
                                            <div className="deal-title d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center gap-1">
                                                    <h3 className="deal__title py-2">
                                                        <span className="d-flex align-items-center" style={{ fontWeight: '600' }}>
                                                            {flight.from_city} <FaExchangeAlt className="mx-2" /> {flight.to_city}
                                                        </span>
                                                        {/* <p className="deal__meta">{formattedTomorrow}</p> */}
                                                    </h3>
                                                </div>
                                                <FaChevronRight className='fs-6 m-0' />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </Card>
            </div>
        </section>
    );
};

export default PopularFlight;
